import config from './config.json';

export const getApiConfig = () => {
  // Use dynamically loaded config from backend if available
  if (window.__ENV_CONFIG__) {
    return {
      apiUrl: window.__ENV_CONFIG__.apiUrl || '',
      sentryUrl: window.__ENV_CONFIG__.sentryUrl,
      googleAnalytics: window.__ENV_CONFIG__.googleAnalytics,
      googleAnalyticsTrackingId: window.__ENV_CONFIG__.googleAnalyticsTrackingId
    };
  }

  // Fallback to static config.json
  return config.deploymentEnv === 'prod'
    ? config.production
    : config.development;
};

export const getConfig = () => {
  if (window.__ENV_CONFIG__) {
    return window.__ENV_CONFIG__;
  }
  return {
    deploymentEnv: config.deploymentEnv,
    version: config.version,
    ...(config.deploymentEnv === 'prod' ? config.production : config.development)
  };
};
